"use client";

import { Card, Button, Progress, useDisclosure } from "@nextui-org/react";
import { useCallback, useState, useEffect, use } from "react";
import ControlMachineAbi from "../../assets/abis/ControlMachine.json";
import { W3ControlMachine, MIN, MAX, W3Token, W3NFT, W3MinerNFT } from "../../constants";
import { waitForTransactionReceipt } from "viem/actions";
import { Token, NFTToken } from "../../constants/types";
import useCurrencyBalance from "../../hooks/useCurrencyBalance";
import useAccountAddress from "../../hooks/useAccountAddress";
import useW3Sign from "../../hooks/useW3Sign";
import { parseEther, parseUnits } from 'viem'; // Import estimateGas from viem
import Toast from "../../components/Toast";
import { useConfig, useClient, useWriteContract, usePublicClient } from "wagmi";
import useW3ControlMachine from "../../hooks/useW3ControlMachine.js";
import Machine from "./components/Machine.js";
import NFTMachine from "./components/NFTMachine.js";
import useW3TeamNum from "../../hooks/useW3TeamNum.js";
import { NumberCount } from "../../components/NumberCount/index.js";
import useW3Reward from "../../hooks/useW3Reward.js";
import { FaRegQuestionCircle } from "react-icons/fa";
import SwapSettingModal from "../../components/QuestionModal/index.js";
import Wallet from "../../components/Wallet";
import { Share } from "./components/Share";
import useW3LPReward from "../../hooks/useW3LPReward.js";
import { formatUnits } from "viem";

const generateRandomAmount = () => {
  // const min = 0.00043;
  // const max = 0.0006;
  const randomAmount = (Math.random() * (MAX - MIN) + MIN).toFixed(6); // 6 decimal places for precision
  return randomAmount;
};
export default function Mining() {
  // 进度条示例数据（实际项目可从链上读取）
  const account = useW3ControlMachine();
  // console.log(account)
  // const w3singAccount = useW3Sign()
  const publicClient = usePublicClient(); // Get Viem public client
  const client = useClient(); // Get Wagmi client
  const { writeContractAsync } = useWriteContract()
  const [message, setMessage] = useState('');
  const [claiming, setClaiming] = useState(false)
  const [isSuccess, setIsSuccess] = useState(true);
  const [isToastOpen, setIsToastOpen] = useState(false);
  const W3TOKEN = new Token(56, W3Token, 18, 'W3Token', 'W3Token')
  const W3LPTOKEN = new Token(56, '0x5be85e89D810A4c08540b530BB64A80501713a11', 18, 'WPGEO-LP', 'WPGEO-LP')
  // const {
  //   value: allowance,
  //   approve,
  //   loading: approving
  // } = useAllowance(USDTTOKEN, ido)


  const { isOpen: isSettingOpen, onOpen: onSettingOpen, onOpenChange: onSettingOpenChange } = useDisclosure();

  const W3NFTToken = new NFTToken(56, W3NFT, 'W3NFT', 'W3NFT')
  const W3MinerNFTToken = new NFTToken(56, W3MinerNFT, 'W3Miner', 'W3Miner')
  const { value: w3TeamNums, updateTeamNum, onClaimTeamReward, loading } = useW3TeamNum();
  // console.log('w3TeamNums', w3TeamNums);
  const { value:lpreward, onWithdrawUSDTReward, onWithdraWPGEOReward, joinRewardPool ,loading: lloading} = useW3LPReward();
  // console.log('lpreward', lpreward);
  const { value: W3Reward, onWithdraW3Reward, loading: withdrawing } = useW3Reward();
  const address = useAccountAddress()
  const W3TokenBalance = useCurrencyBalance(W3TOKEN, address)
  let W3NFTBalance = useCurrencyBalance(W3NFTToken, address)
  let W3MinerNFTBalance = useCurrencyBalance(W3MinerNFTToken, address)
  const W3LPAmount = useCurrencyBalance(W3LPTOKEN, address)
  const W3LPBalance = Number(formatUnits(W3LPAmount, 18))
// console.log('W3LPBalance', W3LPBalance);
  // const onBuyNFT = useCallback(async () => {
  //   setClaiming(true)
  //   try {

  //     if (!account || account.nftjoined >= account.totalnft) {
  //       setMessage('NFT已全部认购完毕！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }

  //     if (account && account.nftChanged) {
  //       setMessage('您已兑换过NFT，无法重复兑换！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }
  //     if (W3TokenBalance < parseUnits("500", 18)) {
  //       setMessage('帐户USDT不足，无法兑换NFT！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }
  //     if (!w3singAccount || w3singAccount.communitylevel < 6) {
  //       setMessage('社区等级不足6级，无法兑换NFT！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }
  //     if (W3TokenBalance < parseUnits("30000000", 18)) {
  //       console.log(parseUnits("30000000", 18), W3TokenBalance);
  //       setMessage('W3积分不足，无法兑换NFT！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }
  //     const randomAmount = generateRandomAmount();
  //     const txParams = {
  //       address: W3ControlMachine,
  //       abi: ControlMachineAbi,
  //       functionName: 'changeNFT',
  //       value: parseEther(randomAmount),
  //     };
  //     let gasLimit = 30000; // Default gas limit if estimation fails
  //     const estimatedGas = await publicClient.estimateGas(txParams);
  //     gasLimit = Math.floor(Number(estimatedGas) * 20); // Add 20% buffer, convert to number
  //     // console.log('Estimated gas:', estimatedGas.toString());

  //     const hash = await writeContractAsync({
  //       address: W3ControlMachine,
  //       abi: ControlMachineAbi,
  //       functionName: 'changeNFT',
  //       value: parseEther(randomAmount),
  //       gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
  //     })

  //     const receipt = await waitForTransactionReceipt(client, {
  //       hash,
  //       confirmations: 1,
  //     })
  //     console.log('Transaction receipt:', receipt);
  //     if (receipt.status === 'success') {
  //       setMessage('NFT兑换成功！');
  //       setIsSuccess(true);
  //       setIsToastOpen(true);
  //     } else {
  //       setMessage('NFT兑换失败，请重试！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   } finally {
  //     setClaiming(false)
  //   }
  // }, [client, W3TokenBalance, account, writeContractAsync])


  // const onBuyMining = useCallback(async () => {
  //   setClaiming(true)
  //   try {
  //     if (!account || account.startTime > Date.now() / 1000) {
  //       setMessage('兑换活动未开始，敬请期待！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }
  //     if (account && account.personalMachine >= 5) {
  //       setMessage('已达个人矿机上限！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }

  //     if (!account || account.miningjoined >= account.totalmining) {
  //       setMessage('矿机已全部认购完毕！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }
  //     if (USDTBalance < parseUnits("100", 18)) {
  //       setMessage('帐户USDT不足，无法兑换矿机！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }
  //     if (!w3singAccount || w3singAccount.usertotalSignIns < 1) {
  //       setMessage('个人签到等不足3次！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }
  //     if (W3TokenBalance < parseUnits("1000000", 18)) {
  //       setMessage('W3积分不足，无法兑换矿机！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //       setClaiming(false)
  //       return;
  //     }

  //     const randomAmount = generateRandomAmount();
  //     const txParams = {
  //       address: W3ControlMachine,
  //       abi: ControlMachineAbi,
  //       functionName: 'usdtJoin',
  //       value: parseEther(randomAmount),
  //     };
  //     let gasLimit = 30000; // Default gas limit if estimation fails
  //     const estimatedGas = await publicClient.estimateGas(txParams);
  //     gasLimit = Math.floor(Number(estimatedGas) * 20); // Add 20% buffer, convert to number
  //     // console.log('Estimated gas:', estimatedGas.toString());

  //     const hash = await writeContractAsync({
  //       address: W3ControlMachine,
  //       abi: ControlMachineAbi,
  //       functionName: 'usdtJoin',
  //       value: parseEther(randomAmount),
  //       gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
  //     })

  //     const receipt = await waitForTransactionReceipt(client, {
  //       hash,
  //       confirmations: 1,
  //     })
  //     console.log('Transaction receipt:', receipt);
  //     if (receipt.status === 'success') {
  //       setMessage('矿机兑换成功！');
  //       setIsSuccess(true);
  //       setIsToastOpen(true);
  //     } else {
  //       setMessage('矿机兑换失败，请重试！');
  //       setIsSuccess(false);
  //       setIsToastOpen(true);
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   } finally {
  //     setClaiming(false)
  //   }
  // }, [client, W3TokenBalance, account, writeContractAsync])
  const onOpen = useCallback(async () => {
    setClaiming(true)
    try {
      const randomAmount = generateRandomAmount();
      const txParams = {
        address: W3ControlMachine,
        abi: ControlMachineAbi,
        functionName: 'open',
        value: parseEther(randomAmount),
      };
      let gasLimit = 30000; // Default gas limit if estimation fails
      const estimatedGas = await publicClient.estimateGas(txParams);
      gasLimit = Math.floor(Number(estimatedGas) * 20); // Add 20% buffer, convert to number
      // console.log('Estimated gas:', estimatedGas.toString());

      const hash = await writeContractAsync({
        address: W3ControlMachine,
        abi: ControlMachineAbi,
        functionName: 'open',
        value: parseEther(randomAmount),
        gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
      })

      const receipt = await waitForTransactionReceipt(client, {
        hash,
        confirmations: 1,
      })
      console.log('Transaction receipt:', receipt);
      if (receipt.status === 'success') {
        setMessage('矿机开启成功！');
        setIsSuccess(true);
        setIsToastOpen(true);
      } else {
        setMessage('矿机开启失败，请重试！');
        setIsSuccess(false);
        setIsToastOpen(true);
      }
    } catch (e) {
      console.log(e)
    } finally {
      setClaiming(false)
    }
  }, [client, W3TokenBalance, account, writeContractAsync])
  const onClaimReward = useCallback(async () => {
    setClaiming(true)
    try {

      const randomAmount = generateRandomAmount();
      const txParams = {
        address: W3ControlMachine,
        abi: ControlMachineAbi,
        functionName: 'claimUSDTReward',
        value: parseEther(randomAmount),
      };
      let gasLimit = 30000; // Default gas limit if estimation fails
      const estimatedGas = await publicClient.estimateGas(txParams);
      gasLimit = Math.floor(Number(estimatedGas) * 20); // Add 20% buffer, convert to number
      // console.log('Estimated gas:', estimatedGas.toString());

      const hash = await writeContractAsync({
        address: W3ControlMachine,
        abi: ControlMachineAbi,
        functionName: 'claimUSDTReward',
        value: parseEther(randomAmount),
        // gas: gasLimit, // Set gas limit to 30,000 to cover the required 21,432
      })

      const receipt = await waitForTransactionReceipt(client, {
        hash,
        confirmations: 1,
      })
      // console.log('Transaction receipt:', receipt);
      if (receipt.status === 'success') {
        setMessage('提取成功！');
        setIsSuccess(true);
        setIsToastOpen(true);
      } else {
        setMessage('提取失败，请重试！');
        setIsSuccess(false);
        setIsToastOpen(true);
      }
    } catch (e) {
      console.log(e)
    } finally {
      setClaiming(false)
    }
  }, [client, W3TokenBalance, account, writeContractAsync])
  return (
    <div className="min-h-screen max-w-lg mx-auto bg-background text-white p-4 flex flex-col">
     {lpreward &&(<section className=" text-xs">
        <div className="grid grid-cols-2 gap-4 mb-6">
          <Card className="bg-gray-100 dark:bg-box p-4 text-center " style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }} >
            <p className="text-gray-400">已产出WPGEO</p>
                <p className="font-bold text-yellow-400 text-xl"><NumberCount value={lpreward.WPGEOReward} decimals={2}/></p>
          </Card>
          <Card className="bg-gray-100 dark:bg-box p-4 text-center " style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }} >
            <p className="text-gray-400">已产出USDT</p>
              <p className="font-bold text-yellow-400 text-xl"><NumberCount value={lpreward.USDTReward} decimals={2}/></p>
          </Card>
        </div>
        {/* <Toast
          message={message}
          isOpen={isToastOpen}
          onClose={() => setIsToastOpen(false)}
        /> */}
        {/* 交换区域 */}
        <div className="relative mb-6">
          <img
            src="/images/profile-bg.png" // 替换为实际背景图片URL
            alt="Exchange Background"
            className="w-full h-24 object-cover rounded-lg"
          />
          <div className="absolute inset-0 flex items-center justify-around	">
            <div className="flex flex-col items-center">
              {/* <p className="text-button  font-semibold">签到领取空投</p> 
              {account && account.signIns ? (
                <Button className="dark:bg-buttontext-black font-semibold" disabled>今日已签到</Button>
              ) : (
                <Button className="dark:bg-button text-black font-semibold" onPress={onClaim}>签到</Button>
              )}
              */}
              <p className="text-button  font-semibold">LP余额:<NumberCount value={W3LPBalance} decimals={2} /></p>
              {lpreward && lpreward.addressExists ? (
                <Button className="dark:bg-button text-black font-semibold " disabled>已激活LP分红</Button>
              ) : (
                <Button className="dark:bg-button text-black font-semibold" onPress={joinRewardPool} >激活LP挖矿分红</Button>
              )}
            </div>
            <Wallet>领取奖励</Wallet>
          </div>
        </div>


      </section>)}
      <Toast
        message={message}
        isSuccess={isSuccess}
        isOpen={isToastOpen}
        onClose={() => setIsToastOpen(false)}
      />
      {/* ==================== SWAP 股东卡牌 ==================== */}
      

      {/* ==================== 股东 NFT 卡牌 ==================== */}
      {W3NFTBalance > 0 && (
        <div className="flex items-center gap-2  mb-2 text-xs">
          <div className="w-1 h-4 bg-button" />
          <h2 className="text-button font-semibold">股东NFT卡牌</h2>
        </div>)}
      {Array.from({ length: Number(W3NFTBalance) }, (_, index) => (<>
        <NFTMachine _index={index} />
      </>))
      }

      {/* ==================== SWAP 矿机（节点） ==================== */}

      {account && account.unOpenMachines > 0 && (
        <div className="flex items-center gap-2 mt-6 mb-2 text-xs">
          <div className="w-1 h-4 bg-button" />
          <h2 className="text-button font-semibold">SWAP矿机</h2>
        </div>)}
      {account && Array.from({ length: Number(account.unOpenMachines) }, (_, index) => (<>
        <Card className="bg-gray-100 dark:bg-box p-6 rounded-xl shadow-xl" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
          <div className="flex gap-4 items-center">
            <img
              src="/images/mining.png"
              alt="SWAP矿机节点"
              className="w-36 h-18 object-cover rounded-lg border border-yellow-600"
            />
            <div className="flex-1 grid grid-cols-2 gap-4">
              <div className="text-center">
                <p className="text-gray-400 text-xs">剩余量</p>
                <p className="text-button text-xs font-bold">50000</p>
              </div>
              <div className="text-center">
                <p className="text-gray-400 text-xs">已产出</p>
                <p className="text-button text-xs font-bold">0.00</p>
              </div>
              <div className="text-center">
                <p className="text-gray-400 text-xs">已领取</p>
                <p className="text-button text-xs font-bold">0.00</p>
              </div>
              <Button className="bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg" disabled={claiming} onPress={onOpen} isLoading={claiming}>
                开启
              </Button>
            </div>
          </div>
        </Card>
      </>))}
      {/* ==================== 已开启矿机 ==================== */}
      {Number(W3MinerNFTBalance) > 0 && (
        <div className="flex items-center gap-2 mt-6  text-xs">
          <div className="w-1 h-4 bg-button" />
          <h2 className="text-button font-semibold">已开启矿机</h2>
        </div>
      )}
      {Array.from({ length: Number(W3MinerNFTBalance) }, (_, index) => {
        return (<Machine _index={index} />)
      })}
      {/* ==================== W3 (LP 挖矿) ==================== 

      <div className="flex items-center gap-2 mt-6 mb-2 text-xs">
        <div className="w-1 h-4 bg-button" />
        <h2 className="text-button font-semibold">W3(LP挖矿)</h2>
      </div>

      <Card className="bg-gray-100 dark:bg-box p-6 rounded-xl shadow-xl" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
        <div className="flex gap-4 items-center">
          <img
            src="/images/mining.png"
            alt="W3 LP挖矿"
            className="w-36 h-18 object-cover rounded-lg border border-yellow-600"
          />
          <div className="flex-1 grid grid-cols-2 gap-4">
            <div className="text-center">
              <p className="text-gray-400 text-xs">已质押LP</p>
              <p className="text-button text-xs font-bold">50000</p>
            </div>
            <div className="text-center">
              <p className="text-gray-400 text-xs">WPGEO</p>
              <p className="text-button text-xs font-bold">0.00</p>
            </div>
            <Button className="bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg">
              质押
            </Button>
            <Button className="bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg">
              领取
            </Button>
          </div>
        </div>
      </Card>
*/}
      {/* ==================== 奖励中心 ==================== */}
      <div className="flex items-center gap-2 mt-6 mb-2 text-xs">
        <div className="w-1 h-4 bg-button" />
        <h2 className="text-button font-semibold">奖励中心</h2>
      </div>
      {account && (
        <Card className="bg-gray-100 dark:bg-box p-6 rounded-xl shadow-xl" style={{ boxShadow: "inset 0 3px 3px rgba(0, 0, 0, 0.5)" }}>
          <div className="grid grid-cols-3 gap-y-8 text-center">
            <div className="flex flex-col gap-y-4">
              <p className="text-gray-400 text-xs">社区SWAP矿机</p>
              <p className="text-button text-xl font-bold">{w3TeamNums && w3TeamNums.teamnum}</p>
            </div>
            <div className="flex flex-col gap-y-4">
              {lpreward && lpreward.addressExists ? (
                <>
                  <p className="text-gray-400 text-xs">已激活(LP)</p>
                  <p className="text-button text-xl font-bold"><NumberCount value={W3LPBalance} decimals={2} /></p>
                </>
              ) : (
                                <>
                  <p className="text-gray-400 text-xs">未激活(LP)</p>
                  <p className="text-button text-xl font-bold"><NumberCount value={W3LPBalance} decimals={2} /></p>
                </>
              )}
            </div>
            <div className="flex flex-col gap-y-4">
              <p className="flex text-gray-400 text-xs">SWAP加权分红<span className="text-red"><FaRegQuestionCircle onClick={onSettingOpen} /></span></p>
              {w3TeamNums && w3TeamNums.isUpLevel ? (
                <button className="bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg" disabled={loading} onClick={updateTeamNum} isLoading={loading} >升级</button>
              ) : (w3TeamNums && w3TeamNums.myteamLevel > 0 ? (
                <button className="bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg" disabled={loading} onClick={onClaimTeamReward} isLoading={loading} >{w3TeamNums && w3TeamNums.withdrawableDividendOf}U可提</button>) : (<p className="text-button text-xl font-bold">0%</p>)
              )}
            </div>
            <div className="flex flex-col gap-y-4">
              <p className="text-gray-400 text-xs">社区W3奖励</p>
              <p className="text-button text-xl font-bold">{W3Reward && <NumberCount value={W3Reward.W3Reward} decimals={2} />}</p>
            </div>
            <div className="flex flex-col gap-y-4">
              <p className="text-gray-400 text-xs">WPGEO产出</p>
              <p className="text-button text-xl font-bold">{lpreward && <NumberCount value={lpreward.WPGEOReward} decimals={2} />}</p>
            </div>
            <div className="flex flex-col gap-y-4">
              <p className="text-gray-400 text-xs">分红USDT</p>
              <p className="text-button text-xl font-bold">{lpreward && (<NumberCount value={lpreward.USDTReward} decimals={2} />)}</p>
            </div>
          </div>

          <div className="flex gap-2 mt-4">
            <Button className="flex-1 bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg" onPress={onWithdraW3Reward} isLoading={withdrawing} disabled={withdrawing}>
              W3领取
            </Button>
            <Button className="flex-1 bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg" onPress={onWithdraWPGEOReward} isLoading={lloading} disabled={lloading}>
              WPGEO领取
            </Button>
            <Button className="flex-1 bg-button text-black min-w-10 h-8 text-xs font-medium rounded-lg" onPress={onWithdrawUSDTReward} isLoading={lloading} disabled={lloading}>
              分红领取
            </Button>
          </div>
        </Card>)}
      <SwapSettingModal
        isOpen={isSettingOpen}
        onOpenChange={onSettingOpenChange}
      />
    </div>
  )
}